export default __webpack_public_path__ + "static/media/rank-2.dd241c9f.svg";